import { useAppDispatch, useAppSelector } from 'app/hooks/redux-thunk';
import { iso8601ToFullMonthAndYear } from 'app/utils/date-utils';
import { getAnonymizedCurrentPageUrl, GtmElementCategory, GtmElementCta } from 'app/utils/gtm-tracking-utils';
import { getInvoicePdf } from 'app/store/actions/invoice-thunks';
import { getDataLayers } from 'app/utils/trackingService';

export const useDownloadInvoicePdf = () => {
  const { fetchStatus } = useAppSelector((state) => state.invoice.invoicePdf);

  const customerCrmId = useAppSelector((state) => state.userContext.selectedCustomerLocation?.customerCrmId);
  const dispatch = useAppDispatch();

  const downloadPdf = (invoice: MinesiderBackend.Invoice, elementCategory: GtmElementCategory) => {
    if (!invoice || !invoice.billNumber || !customerCrmId || !invoice.billingAccountId) {
      return;
    }
    dispatch(
      getInvoicePdf({
        invoiceAccountCrmId: invoice.billingAccountId,
        invoiceId: invoice.billNumber,
      }),
    );

    getDataLayers().customEvents.pushButtonClickEvent({
      element_cta: GtmElementCta.INVOICE_DOWNLOAD_PDF,
      element_category: elementCategory,
      element_description: iso8601ToFullMonthAndYear(invoice?.billDate || ''),
      element_status: invoice.settlementState,
      page_url: getAnonymizedCurrentPageUrl(),
    });
  };

  return { downloadPdf, downloadFetchStatus: fetchStatus };
};
